import { useState, useEffect } from 'react';
import { AuthFetch } from '../services/api';
import { notify } from '../utils/utils';


export const useTipoUsuario = () => {
    const [ tipoUsuarios, setTipoUsuario ] = useState([]);

    // useEffect(() => {
    //     listarTipoUsuarios();
    // }, []);

    const listarTipoUsuarios = async () => {
        try
        {
            const response = await AuthFetch('/User/types')
            if (response.isValid) {
                setTipoUsuario(response.content);
            } else {
                alert(response.content);
            }
        }
        catch(error)
        {
            notify('Ocurrió un error','error')

        }
        
    }
    return { listarTipoUsuarios, tipoUsuarios };
}